const userAgent = navigator.userAgent;
var isSafari =
	/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
	'webkitAppearance' in document.documentElement.style;
const safariVersion = /version\/(\d+\.\d+)/i.exec(userAgent);

if (isSafari && safariVersion) {
	const version = parseFloat(safariVersion[1]);
	if (version <= 14.1) {
		document.body.classList.add('unsupported-safari');
	} else {
		document.body.classList.add('supported-browser');
	}
}

let tabs = document.querySelectorAll('.custom-product-tabs--toggle');
let tabsContent = document.querySelectorAll('.custom-product-tabs__content');
tabs.forEach((tab) => {
	tab.addEventListener('click', (event) => {
		let tabId = event.target.dataset.id;
		tabs.forEach((tab) => tab.classList.remove('active'));
		event.target.classList.add('active');
		tabsContent.forEach((content) => content.classList.remove('active'));
		tabsContent.forEach((content) =>
			content.dataset.id == tabId
				? content.classList.add('active')
				: false
		);
	});
});
let thumbs = document.querySelector('.my-thumbs');
if (thumbs) {
	const mediaQuery = '(max-width: 989px)';
	const mediaQueryList = window.matchMedia(mediaQuery);
	if (mediaQueryList) {
		setAttrForThumbSlider(mediaQueryList, thumbs);
	}
	mediaQueryList.addEventListener('change', (event) => {
		setAttrForThumbSlider(event, thumbs);
	});
}
function setAttrForThumbSlider(event, thumbs) {
	if (event.matches) {
		thumbs.setAttribute('slides-per-view', '5');
		thumbs.setAttribute('direction', 'horizontal');
		thumbs.setAttribute('space-between', '12');
	} else {
		thumbs.setAttribute('slides-per-view', 'auto');
		thumbs.setAttribute('direction', 'vertical');
		thumbs.removeAttribute('space-between');
	}
}

class DisclosureModal extends HTMLElement {
	constructor() {
		super();
		this.disclosure = this;
		this.window = window;
	}

	connectedCallback() {
		this.bindEvents();
	}

	bindEvents() {
		this.window.addEventListener('click', this.onOverlayClick.bind(this));
	}

	getDataForDisclosure(data) {
		this.data = data;
	}

	buildDisclosureWithData() {
		const {
			image1Url,
			image1Alt,
			image1Width,
			image1Height,
			video,
			previewImage,
			controls,
			autoplay,
			loop,
			muted,
			image2Url,
			image2Alt,
			image2Width,
			image2Height,
			title,
			biography,
			height,
			weight,
			age,
			signature,
			location,
			participated,
			won,
			winRate,
			disclosureId,
			disclosureCount,
			caller,
		} = this.data;
		return `
        <div class="flex_card_details slide-in-${
			caller === 'disclosure-opener'
				? 'top'
				: caller === 'previous-button'
				? 'right'
				: 'left'
		}">
            <div class="flex_card_details_container">
                <div class="flex_card_title_wrapper">
                    <previous-button class="arrow arrow_prev" data-disclosure-id="${disclosureId}" data-disclosure-count="${disclosureCount}" name="previous-button" target="stable-flex-card">
                        <svg width="43" height="30" viewBox="0 0 43 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M41 17C42.1046 17 43 16.1046 43 15C43 13.8954 42.1046 13 41 13L41 17ZM0.585785 13.5858C-0.195263 14.3668 -0.195263 15.6332 0.585785 16.4142L13.3137 29.1421C14.0948 29.9232 15.3611 29.9232 16.1421 29.1421C16.9232 28.3611 16.9232 27.0948 16.1421 26.3137L4.82843 15L16.1421 3.68629C16.9232 2.90524 16.9232 1.63891 16.1421 0.857862C15.3611 0.0768134 14.0948 0.0768133 13.3137 0.857862L0.585785 13.5858ZM41 13L2 13L2 17L41 17L41 13Z" fill="black"/>
                        </svg>
                    </previous-button>
                    ${
						title &&
						`<h2 class="flex_card_details_title">${title}</h2>`
					}
                    <next-button class="arrow arrow_next" data-disclosure-id="${disclosureId}" data-disclosure-count="${disclosureCount}" name="next-button" target="stable-flex-card">
                        <svg width="43" height="30" viewBox="0 0 43 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2 13C0.895431 13 9.65645e-08 13.8954 0 15C-9.65645e-08 16.1046 0.89543 17 2 17L2 13ZM42.4142 16.4142C43.1953 15.6332 43.1953 14.3668 42.4142 13.5858L29.6863 0.857867C28.9052 0.076818 27.6389 0.0768178 26.8579 0.857867C26.0768 1.63892 26.0768 2.90525 26.8579 3.68629L38.1716 15L26.8579 26.3137C26.0768 27.0948 26.0768 28.3611 26.8579 29.1421C27.6389 29.9232 28.9052 29.9232 29.6863 29.1421L42.4142 16.4142ZM2 17L41 17L41 13L2 13L2 17Z" fill="black"/>
                        </svg>
                    </next-button>
                </div>
                <div class="flex_card_details_wrapper">
                    ${
						image1Url != ''
							? `<div class="flex_card_details_image1 flex_card_details_image">
                        <img src="${image1Url}" alt="${image1Alt}" class="flex_card_image1 flex_card_image" width="${image1Width}" height="${image1Height}" loading="lazy">
                    </div> `
							: ''
					}
                    <div class="flex_card_details_information">
                        ${
							biography !== ''
								? `<div class="biography_wrapper">
                            <div class="information_title_wrapper">
                                <h3 class="information_title">BIOGRAPHY</h3>
                            </div>
                            <div class="information_details">
                                ${biography}
                            </div>
                        </div>`
								: ''
						}
                        <div class="biography_details_wrapper">
                            <div class="row1">
                                <div class="row1child1">
                                    <h6 class="child_value">
                                        ${height.replace("'", '<span>’</span>')}
                                    </h6>
                                    <div class="child_title">Height</div>
                                </div>
                                <div class="row1child2">
                                    <h6 class="child_value">
                                        ${signature}
                                    </h6>
                                    <div class="child_title">Signature Move</div>
                                </div>
                            </div>
                            <div class="row2">
                                <div class="row2child">
                                    <div class="child_title">From</div>
                                    <h6 class="child_value">
                                        ${location}
                                    </h6>
                                </div>
                            </div>                            
                        </div>
                    </div>
                   	${
						video != ''
							? `<div class="flex_card_details_image2 flex_card_details_image">
							<video-player class="video_player flex_card_image2 flex_card_image"  data-controls="${controls}" data-autoplay="${autoplay}" data-loop="${loop}" data-muted="${muted}" data-location="disclosure-modal">
								<video ${
									window.innerWidth <= 768
										? `controls`
										: `autoplay muted loop`
								} width="1080" height="1920" poster="${previewImage}">
									<source src="${video}" type="video/mp4">
									Your browser does not support the video tag.
								</video>
							</video-player>
						</div>`
							: ''
					}
                </div>
            </div>
        </div>`;
	}

	appendDisclosure() {
		this.innerHTML = this.buildDisclosureWithData();
	}

	removeDisclosure() {
		this.innerHTML = '';
	}

	onToggle() {
		const { disclosureId } = this.data;
		if (
			!this.classList.contains('active') ||
			(this.classList.contains('active') &&
				this.getAttribute('disclosureId') != disclosureId)
		) {
			this.onOpen(disclosureId);
		} else {
			this.onClose();
		}
	}

	onOpen(disclosureId) {
		this.setAttribute('disclosureId', disclosureId);
		this.appendDisclosure();
		this.classList.add('active');
	}

	onClose() {
		this.removeAttribute('disclosureId');
		this.removeDisclosure();
		this.classList.remove('active');
	}

	onOverlayClick(event) {
		if (event.target === this) {
			this.onClose();
		}
	}
}
customElements.define('disclosure-modal', DisclosureModal);

class DisclosureOpener extends DisclosureModal {
	constructor() {
		super();
		this.disclosureId = this.getAttribute('target');
		this.disclosure = document.querySelector(`#${this.disclosureId}`);
		const caller = 'disclosure-opener';
		this.dataObj = { ...this.dataset, caller };
	}

	connectedCallback() {
		this.addEventListener('click', () =>
			this.onDisclosureOpen(this.dataObj, this.caller)
		);
	}

	onDisclosureOpen(data) {
		const {
			image1Url = '',
			image1Alt = '',
			image1Width = '',
			image1Height = '',
			video = '',
			previewImage = '',
			controls = false,
			autoplay = false,
			loop = false,
			muted = false,
			image2Url = '',
			image2Alt = '',
			image2Width = '',
			image2Height = '',
			title = '',
			biography = '',
			height = '',
			weight = '',
			age = '',
			signature = '',
			location = '',
			participated = '',
			won = '',
			winRate = '',
			disclosureId = '',
			disclosureCount = '',
			caller = '',
		} = data;
		this.dataObject = {
			image1Url,
			image1Alt,
			image1Width,
			image1Height,
			video,
			previewImage,
			controls,
			autoplay,
			loop,
			muted,
			image2Url,
			image2Alt,
			image2Width,
			image2Height,
			title,
			biography,
			height,
			weight,
			age,
			signature,
			location,
			participated,
			won,
			winRate,
			disclosureId,
			disclosureCount,
			caller,
		};
		this.disclosure.getDataForDisclosure(this.dataObject);
		this.disclosure.onToggle();
		caller != 'next-button' &&
			caller != 'previous-button' &&
			this.disclosure.scrollIntoView({
				alignToTop: false,
				behavior: 'smooth',
				block: 'start',
			});
	}

	onPreviousCall(instanceId, caller) {
		const disclosureOpener = document.querySelector(
			`disclosure-opener[data-disclosure-id="${instanceId}"]`
		);
		this.dataObj = { ...disclosureOpener.dataset, caller };
		this.onDisclosureOpen(this.dataObj);
	}

	onNextCall(instanceId, caller) {
		const disclosureOpener = document.querySelector(
			`disclosure-opener[data-disclosure-id="${instanceId}"]`
		);
		this.dataObj = { ...disclosureOpener.dataset, caller };
		this.onDisclosureOpen(this.dataObj);
	}
}
customElements.define('disclosure-opener', DisclosureOpener);

class NextButton extends DisclosureOpener {
	constructor() {
		super();
		this.caller = this.getAttribute('name');
		this.currentDisclosureInstanceId =
			this.getAttribute('data-disclosure-id');
		this.disclosureInstanceCount = this.getAttribute(
			'data-disclosure-count'
		);
		this.nextDisclosureInstanceId =
			this.currentDisclosureInstanceId === this.disclosureInstanceCount
				? 1
				: Number(this.currentDisclosureInstanceId) + 1;
	}

	connectedCallback() {
		this.addEventListener('click', () =>
			this.onNext(this.nextDisclosureInstanceId, this.caller)
		);
	}

	onNext(instanceId, caller) {
		this.onNextCall(instanceId, caller);
	}
}
customElements.define('next-button', NextButton);
class PreviousButton extends DisclosureOpener {
	constructor() {
		super();
		this.caller = this.getAttribute('name');
		this.currentDisclosureInstanceId =
			this.getAttribute('data-disclosure-id');
		this.disclosureInstanceCount = this.getAttribute(
			'data-disclosure-count'
		);
		this.previousDisclosureInstanceId =
			Number(this.currentDisclosureInstanceId) === 1
				? Number(this.disclosureInstanceCount)
				: Number(this.currentDisclosureInstanceId) - 1;
	}

	connectedCallback() {
		this.addEventListener('click', () =>
			this.onPrevious(this.previousDisclosureInstanceId, this.caller)
		);
	}

	onPrevious(instanceId, caller) {
		this.onPreviousCall(instanceId, caller);
	}
}
customElements.define('previous-button', PreviousButton);

class VideoPlayer extends HTMLElement {
	constructor() {
		super();
		this.video = this.querySelector('video');
		this.controls = this.dataset.controls;
		this.autoplay = this.dataset.autoplay;
		this.loop = this.dataset.loop;
		this.muted = this.dataset.muted;
		this.location = this.dataset.location;
	}

	connectedCallback() {
		this.bindEvents();
	}

	bindEvents() {
		if (this.location !== 'disclosure-modal' && window.innerWidth >= 768) {
			this.addEventListener('mouseenter', this.play);
			this.addEventListener('mouseleave', this.pause);
		}
	}

	play() {
		this.video?.play();
		if (this.controls == true) {
			this.video.setAttribute('controls', '');
		}
		if (this.autoplay) {
			this.video.setAttribute('autoplay', '');
			this.video.setAttribute('muted', '');
		}
		if (this.loop) {
			this.video.setAttribute('loop', '');
		}
		if (this.muted) {
			this.video.setAttribute('muted', '');
		}
	}

	pause() {
		this.video?.pause();
		this.video.currentTime = 0;
		if (this.controls) {
			this.video.removeAttribute('controls');
		}
		if (this.autoplay) {
			this.video.removeAttribute('autoplay');
			this.video.removeAttribute('muted');
		}
		if (this.loop) {
			this.video.removeAttribute('loop');
		}
		if (this.muted) {
			this.video.removeAttribute('muted');
		}
	}
}
customElements.define('video-player', VideoPlayer);
